/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */

export type PrincipalType = typeof PrincipalType[keyof typeof PrincipalType];


export const PrincipalType = {
  NUMBER_0: 0,
  NUMBER_1: 1,
} as const;
